import React from 'react'
import "./portfolio.css"
import IMG1 from "../../assets/portfolio1.jpg"
import IMG2 from "../../assets/portfolio2.jpg"
import IMG3 from "../../assets/portfolio3.jpg"
import IMG4 from "../../assets/portfolio4.jpg"
import IMG5 from "../../assets/portfolio5.jpg"
import IMG6 from "../../assets/portfolio6.jpg"
import IMG7 from "../../assets/portfolio7.png"
import IMG8 from "../../assets/portfolio8.png"
import IMG9 from "../../assets/portfolio9.png"
import IMG10 from "../../assets/portfolio10.png"
import IMG11 from "../../assets/portfolio11.png"

const data =[
  {
    id:1,
    image:IMG10,
    title:"Product Picker (Shopify)",
    github:"https://github.com/alishaikh9890/Product-Picker",
    demo:"https://mock-commerce-picker.netlify.app/"
  },
  {
    id:1,
    image:IMG7,
    title:"Star Wars Nested API's",
    github:"https://github.com/alishaikh9890/star-wars-planets",
    demo:"https://star-wars-planets-red.vercel.app/"
  },
  {
    id:1,
    image:IMG11,
    title:"Note Keeper",
    github:"https://github.com/alishaikh9890/note-keeper",
    demo:"https://note-keeper-peach-six.vercel.app/"
  },
  {
    id:1,
    image:IMG8,
    title:"Movie App using TMDB API",
    github:"https://github.com/alishaikh9890/movies_js",
    demo:"https://movies-js-gamma.vercel.app/"
  },
  {
    id:1,
    image:IMG9,
    title:"Movie App using TMDB API",
    github:"https://github.com/alishaikh9890/To-Do-App",
    demo:"https://to-do-app-alishan.netlify.app/"
  },
  {
    id:1,
    image:IMG1,
    title:"Lifestyle stores Clone",
    github:"https://github.com/alishaikh9890/lifestylestores.com",
    demo:"https://lifestylestoresclone.netlify.app/"
  },
  {
    id:1,
    image:IMG2,
    title:"Bigbasket Clone",
    github:"https://github.com/alishaikh9890/bigBasketCloneProject",
    demo:"https://bigbasketteam11clone.netlify.app/"
  },  {
    id:1,
    image:IMG3,
    title:"Medium Clone",
    github:"https://github.com/alishaikh9890/medium-clone",
    demo:"https://the-medium-clone.netlify.app/"
  },  {
    id:1,
    image:IMG4,
    title:"ACKO Clone",
    github:"https://github.com/alishaikh9890/ACKO.com_Clone",
    demo:"www.google.com"
  },
  {
    id:1,
    image:IMG5,
    title:"Expernse Tracker",
    github:"https://github.com",
    demo:"www.google.com"
  },
  {
    id:1,
    image:IMG6,
    title:"IMDB Search",
    github:"https://github.com",
    demo:"www.google.com"
  },
]

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My  Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
        {
          data.map(({id, image, title, github, demo}) =>{
            return(
              <article key={id} className='portfolio_item'>
              <div className="portfolio_item-image">
                <img src={image} alt="" />
              </div>
              <h3>{title}</h3>
              <div className="portfolio_item-cta">
              <a href={github} className='btn' target="_blank" rel="noreferrer noopener">Github</a>
              <a href={demo} className='btn btn-primary' target="_blank" rel="noreferrer noopener">Live Demo</a>
              </div>
            </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio
